import React, { Component } from "react";
import { DatePicker, Button, message, Spin } from "antd";
import { parse } from "qs";
import { connect } from "dva";
import moment from "moment";

import styles from "./index.less";
import Container from "../../../../../components/Container";

const { RangePicker } = DatePicker;

@connect(({ projectSetting }) => ({
  planTime: projectSetting.planTime,
  spinProps: projectSetting.spinProps,
}))
class SettingView extends Component {
  constructor(props) {
    super(props);
    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId } = query;

    this.state = {
      currentProjectId,
      isSubmit: true
    };
  }

  componentDidMount() {
    this.getDetail();
  }

  getDetail = () => {
    // 获取详情
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectSetting/fetchPlanTime",
      payload: {
        projectId: currentProjectId
      },
      callback: this.handleSetOriginalPlanTime
    });
  };

  // 设置初始state时间详情
  handleSetOriginalPlanTime = () => {
    // const dateFormat = 'YYYY/MM/DD';
    const { planTime } = this.props;
    const {
      startTime,
      endTime,
      selfEvaluationStartTime,
      selfEvaluationEndTime,
      otherEvaluationStartTime,
      otherEvaluationEndTime
    } = planTime;
    this.setState({
      startTime,
      endTime,
      selfEvaluationStartTime,
      selfEvaluationEndTime,
      otherEvaluationStartTime,
      otherEvaluationEndTime
    });
  };

  // 修改自评填报时间
  handleChangeEvaluationDate = current => {
    const { startTime, endTime } = this.state;
    const selfEvaluationStartTime = current[0] && current[0].valueOf();
    const selfEvaluationEndTime = current[1] && current[1].valueOf();

    if (
      selfEvaluationStartTime < startTime ||
      selfEvaluationEndTime > endTime
    ) {
      message.error("自评填报的时间范围应该在项目计划时间之内");
    } else {
      this.setState({
        selfEvaluationStartTime,
        selfEvaluationEndTime,
        otherEvaluationStartTime: null,
        otherEvaluationEndTime: null,
        isSubmit: true
        // otherEvaluationStartTime,
        // otherEvaluationEndTime
      });
    }
  };

  // 修改专家评估时间
  handleChangeOtherEvaluationDate = current => {
    const { selfEvaluationEndTime, endTime } = this.state;
    const otherEvaluationStartTime = current[0] && current[0].valueOf();
    const otherEvaluationEndTime = current[1] && current[1].valueOf();
    if (otherEvaluationStartTime < selfEvaluationEndTime) {
      message.error("专家评估的起始时间要大于自评填报时间");
    } else if (otherEvaluationEndTime > endTime) {
      message.error("专家评估的起始时间要小于于自评填报时间");
    } else {
      this.setState({
        otherEvaluationStartTime: current[0] && current[0].valueOf(),
        otherEvaluationEndTime: current[1] && current[1].valueOf(),
        isSubmit: false
      });
    }
  };

  // 设置自评填报时间的可选范围
  setEvaluationDisabledDate = current => {
    const { startTime, endTime } = this.state;
    return current < moment(startTime) || current > moment(endTime);
  };

  // 设置专家评估时间的可选范围
  setOtherEvaluationDisabledDate = current => {
    const { selfEvaluationEndTime } = this.state;
    const { endTime } = this.state;
    return current < moment(selfEvaluationEndTime) || current > moment(endTime);
  };

  // 提交修改后的时间
  handleSubmitTime = () => {
    const { dispatch } = this.props;
    const {
      currentProjectId,
      selfEvaluationStartTime,
      selfEvaluationEndTime,
      otherEvaluationStartTime,
      otherEvaluationEndTime
    } = this.state;
    if (!selfEvaluationStartTime) {
      message.error("自评填报时间不能为空");
    } else if (!otherEvaluationStartTime) {
      message.error("专家评估时间不能为空");
    } else {
      dispatch({
        type: "projectSetting/fetchSetPlanTime",
        payload: {
          projectId: currentProjectId,
          selfEvaluationStartTime,
          selfEvaluationEndTime,
          otherEvaluationStartTime,
          otherEvaluationEndTime
        },
        callback: this.getDetail
      });
    }
  };

  // 渲染底部按钮
  renderFooterBtn = () => {
    const { isSubmit } = this.state;
    const footerParams = {
      states: !0, // 是否展示底部按钮区域，默认为false 不展示
      demFooter: (
        <>
          <Button
            type="primary"
            onClick={this.handleSubmitTime}
            disabled={isSubmit}
          >
            保存修改
          </Button>
        </>
      )
    };
    return footerParams;
  };

  render() {
    const { spinProps } = this.props
    const {
      startTime,
      endTime,
      selfEvaluationStartTime,
      selfEvaluationEndTime,
      otherEvaluationStartTime,
      otherEvaluationEndTime
    } = this.state;

    const containerProps = {
      breStates: true,
      version: 2,
      footerParams: this.renderFooterBtn(),
      isPathParams: true
    };
    // const { startTime,endTime,selfEvaluationStartTime,selfEvaluationEndTime,otherEvaluationStartTime,otherEvaluationEndTime } = planTime
    const originalPlanTime = [moment(startTime), moment(endTime)];
    const evaluationTime = [
      moment(selfEvaluationStartTime),
      moment(selfEvaluationEndTime)
    ];
    const otherEvaluationTime = [
      moment(otherEvaluationStartTime),
      moment(otherEvaluationEndTime)
    ];
    const planTimeProps = {
      value: startTime ? originalPlanTime : null,
      disabled: true
    };
    const evaluationTimeProps = {
      value: selfEvaluationStartTime ? evaluationTime : null,
      disabledDate: this.setEvaluationDisabledDate,
      onChange: this.handleChangeEvaluationDate
    };
    const otherEvaluationTimeProps = {
      value: otherEvaluationStartTime ? otherEvaluationTime : null,
      disabledDate: this.setOtherEvaluationDisabledDate,
      onChange: this.handleChangeOtherEvaluationDate
    };

    return (
      <Container {...containerProps}>
        <div className={styles.setting}>
          <Spin {...spinProps}>
            <div className="container">
              <div>
                <div className="detail-title">指标情况</div>
                <div>
                  <div className="item-wrap">
                    <div className="label">项目计划时间：</div>
                    <RangePicker {...planTimeProps} />
                  </div>
                  <div className="item-wrap">
                    <div className="label">自评填报时间：</div>
                    <RangePicker {...evaluationTimeProps} />
                  </div>
                  <div className="item-wrap">
                    <div className="label">专家评估时间：</div>
                    <RangePicker {...otherEvaluationTimeProps} />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default SettingView;
